import router from '../router';

function normalizeQuery(query, { keepModifiers }) {
    const { keep_view, ...filteredQuery } = query;
    // useful on first render
    if(keepModifiers) {
        return filteredQuery;
    }
    const {
        zoom_departments,
        select_unique,
        selected,
        ...queryWithoutModifiers
    } = filteredQuery;
    return queryWithoutModifiers;
}

function asArray(value) {
    return [].concat(value ?? []);
}

function castQuery(query) {
    if(query?.venues?.artisticFields != null) {
        query.venues.artisticFields = asArray(query.venues.artisticFields);
    }
    if(query?.venues?.festivalArtisticFields != null) {
        query.venues.festivalArtisticFields = asArray(query.venues.festivalArtisticFields);
    }
    if(query?.venues?.labels != null) {
        query.venues.labels = asArray(query.venues.labels);
    }
    if(query?.companies?.artisticFields != null) {
        query.companies.artisticFields = asArray(query.companies.artisticFields);
    }
    if(query?.companies?.festivalArtisticFields != null) {
        query.companies.festivalArtisticFields = asArray(query.companies.festivalArtisticFields);
    }
    return query;
}

function parseValue(value) {
    // explicit ifs because of javascript string conversion (issue #254)
    if(value === '0') {
        return false;
    } else if(value === '1') {
        return true;
    }
    return value;
}

function parseCardTypeValue(cardValue) {
    if(!cardValue) {
        return undefined;
    }
    return Object.entries(cardValue)
        .reduce((res, [key, value]) => ({ ...res, [key]: parseValue(value),  }), {});
}

export function parseQuery(query, { keepModifiers } = {}) {
    return castQuery({
        ...normalizeQuery(query, { keepModifiers }),
        venues: parseCardTypeValue(query.venues),
        companies: parseCardTypeValue(query.companies),
        producers: parseCardTypeValue(query.producers),
    })
}

function serializeValue(value) {
    if(typeof value === 'boolean') {
        return value ? '1' : '0';
    }
    return value;
}

function serializeCardTypeValue(cardValue) {
    return Object.entries(cardValue)
        .reduce((res, [key, value]) => ({ ...res, [key]: serializeValue(value) }), {});
}

export function serializeQuery(query, { keepModifiers } = {}) {
    return {
        ...normalizeQuery(query, { keepModifiers }),
        venues: serializeCardTypeValue(query.venues),
        companies: serializeCardTypeValue(query.companies),
        producers: serializeCardTypeValue(query.producers),
    }
}

export function queriesEquals(a, b) {
    const resolvedA = router.resolve({ query:a });
    const resolvedB = router.resolve({ query:b });
    return resolvedA.href === resolvedB.href;
}